import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  defaultGastronomyOtherFacilities,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const propertyOwnerGastronomySellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    totalFloorSpace: validationRules.totalFloorSpace,
    mainFloorSpace: validationRules.mainFloorSpace,
    auxiliaryArea: validationRules.auxiliaryArea,
    buildingType: validationRules.buildingType,
    price: usePurchasePriceOnRequestCondition,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  otherFacilities: defaultGastronomyOtherFacilities,
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  connections: defaultConnections,
}
